import {
    AnimationBaseController,
    GameApiBase
} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel, RecordsTable} from "../../../Models/GameModel";
import {AnimationContents} from "../../AnimationContents";
import {GameLogic} from "../../../Logic/GameLogic";

import {ButtonController, IButtonControllerOptions} from "../../Common/ButtonController";
import {LocalizationContents} from "../../../LocalizationContents";
import { FieldTypeConstants } from "../../../Constants/FieldTypeConstants";

export interface IIntroScreenControllerOptions
{
}

export class RecordScreenController extends AnimationBaseController {
    $model: RecordsTable;

    public constructor(@Inject private _options:IIntroScreenControllerOptions,
                       @Inject private _gameLogic: GameLogic,
                       @Inject private _arenaApi: GameApiBase) {
        super("RecordScreenController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
            libraryName: "record_board",
            childControllers: {
                CloseButton: {
                    instanceName: "close_button",
                    view: ButtonController,
                    model: this.$model,
                    options: <IButtonControllerOptions>{
                        onClick: () =>{
                            this._gameLogic.hidenModal();
                            this._gameLogic.hideMainMenuContainer();
                            this._gameLogic.showMainMenuContainer();
                        }
                    }
                },
            },
            modelWatch: {
                [FieldTypeConstants.Small]: (val: number) => this.setTextByQuery("light_count", `${val}`),
                [FieldTypeConstants.Medium]: (val: number) => this.setTextByQuery("medium_count", `${val}`),
                [FieldTypeConstants.Big]: (val: number) => this.setTextByQuery("hard_count", `${val}`),
            }
        };
    }

    protected onInitialize(): void {
        this.setTextByQuery("records_title", LocalizationContents.records_title);
        this.setTextByQuery("records_easy", LocalizationContents.records_easy);
        this.setTextByQuery("records_medium", LocalizationContents.records_medium);
        this.setTextByQuery("records_hard", LocalizationContents.records_hard);
        this.setTextByQuery("light_count", `${this.$model[FieldTypeConstants.Small]}`);
        this.setTextByQuery("medium_count", `${this.$model[FieldTypeConstants.Medium]}`);
        this.setTextByQuery("hard_count", `${this.$model[FieldTypeConstants.Big]}`);
    }

    protected onLandscape(): void {
        this.display.scale.set(.65);
    }

    protected onPortrait(): void {
    }

    protected onUpdate(frameRate: number): void {
    }

}

